// extracted by mini-css-extract-plugin
module.exports = {"bodyText":"body-text_bodyText__B2E_Z"};